import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Container, Scale, Button, Dot, Ligature, Text } from './styles';

function ScaleItem({ attempts }) {
  const array = [...Array(5).keys()];

  return (
    <Container>
      <Scale>
        {array.map((index) => {
          const isLast = index !== array.length - 1;
          const active = index === attempts;
          const deactivated = index >= attempts;

          return (
            <Fragment key={index.toString()}>
              <Button disabled>
                <Dot deactivated={deactivated} active={active} />
              </Button>
              {isLast && <Ligature deactivated={deactivated} />}
            </Fragment>
          );
        })}
      </Scale>

      <Scale>
        {array.map((index) => (
          <Button disabled key={index.toString()}>
            <Text>{index + 1}</Text>
          </Button>
        ))}
      </Scale>
    </Container>
  );
}

ScaleItem.propTypes = {
  attempts: PropTypes.number,
};

ScaleItem.defaultProps = {
  attempts: 0,
};

export default ScaleItem;
